import { cn, Skeleton } from '@sib/ui';
import { useDocumentPreviewRendering } from '@sib/ui/hooks';
import { MissingDocuments } from '@sib/ui/icons';
import { NoData } from '@spendbrain/common';
import { useAppTranslation } from '@spendbrain/modules/vendors/hooks';

export interface ContractPreviewProps {
  fileUrl: string;
  title: string;
}

export const ContractPreview = ({ fileUrl, title }: ContractPreviewProps) => {
  const { isPending, isError, onLoad } = useDocumentPreviewRendering();
  const { t } = useAppTranslation();

  return (
    <div className="relative flex-1">
      {isPending ? (
        <div className="flex items-center justify-center bg-white/80 backdrop-blur-sm">
          <Skeleton className="h-[70vh] w-full" />
        </div>
      ) : (
        isError && (
          <NoData
            Icon={MissingDocuments}
            title={t('components.contracts.pdfModal.error.title')}
            description={t('components.contracts.pdfModal.error.message')}
          />
        )
      )}
      <iframe
        src={fileUrl}
        className={cn(
          'h-[70vh] w-full rounded-lg border',
          (isError || isPending) && 'invisible'
        )}
        title={title}
        allow="clipboard-read; clipboard-write"
        onLoad={onLoad}
      />
    </div>
  );
};
